import Layout from "@/components/layout/Layout";
import PaymentRequestConfirmationList from "@/components/finance/PaymentRequestConfirmationList";

const PaymentRequestsConfirmationPage = () => {
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Payment Request Confirmation</h1>
          <p className="text-muted-foreground">
            Confirm payments for approved payment requests
          </p>
        </div>
        <PaymentRequestConfirmationList />
      </div>
    </Layout>
  );
};

export default PaymentRequestsConfirmationPage;
